import { equals } from 'ramda';

import { IMapCenterZoomBounds, IMapBBoxBounds } from '../../types/mapBounds';
import { IBBoxSchema } from '../../repositories/search-engine/entities/bbox/BBoxSchema';

export function bboxToMapBounds({ topLeft, bottomRight }: IBBoxSchema): IMapCenterZoomBounds | IMapBBoxBounds {
  const { lat: top, lng: left } = topLeft;
  const { lat: bottom, lng: right } = bottomRight;

  const bounds: [YMaps.TCoord, YMaps.TCoord] = [
    [bottom, left],
    [top, right],
  ];

  if (equals(bounds[0], bounds[1])) {
    return {
      center: bounds[0],
      zoom: 18,
    };
  }

  return {
    bounds,
  };
}
